import { CLEAR_STATUS } from '@store/action-types/faq';

const clearStatus = () => ({ type: CLEAR_STATUS });

export default clearStatus;
